import { getCurrentInstance, h, Ref, ref, unref, watchEffect } from "@vue/composition-api";
import { InputUserPublicDataSearch } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import usePager from "@/hooks/usePager";
import providers from "@/lib/api";

const DEFAULT_SIZE = 20;

export default function useUserPublicData(
  requestInput?: Ref<InputUserPublicDataSearch>,
  size?: number,
  fields?: string
) {
  const loading = ref(false);
  const {
    enableScroll,
    data,
    items: users,
    getNextPage,
    getFirstPage,
  } = usePager<UserPublicData, InputUserPublicDataSearch>(async page => {
    try {
      loading.value = true;
      return await providers.UserPublicDataProvider.search(
        {
          data: {
            page,
            size: size || DEFAULT_SIZE,
            sort: "ID,DESC",
            disabled: false,
            ...requestInput?.value,
          },
        },
        fields
      );
    } finally {
      loading.value = false;
    }
  });

  const vm = getCurrentInstance();
  watchEffect(() => vm?.$emit("loading", loading.value));

  const render = () => {
    const nodes =
      (vm?.$scopedSlots.default &&
        vm?.$scopedSlots.default({
          users: unref(users),
          enableScroll: unref(enableScroll),
          loading: unref(loading),
          getNextPage,
        })) ||
      [];
    if (nodes.length === 1) return nodes[0];
    else return h("div", nodes);
  };

  return {
    loading,
    data,
    users,
    getNextPage,
    enableScroll,
    getFirstPage,
    render,
  };
}
